import { Input, Select, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormWrapper from './FormWrapper';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers } from '../../../store/slices/user-slice';
import { fetchRoles } from '../../../store/slices/role-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const UserForm = () => {
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mobile, setMobile] = useState('');
    const [roleId, setRoleId] = useState('');

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: users } = useSelector((state) => state.user);
    const { data: roles } = useSelector((state) => state.role);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchUsers());
        dispatch(fetchRoles());
    }, []);

    useEffect(() => {
        if(MODE === 'EDIT' && users.length) {
            const ID = searchParams.get('id');
            const selectedUser = users.filter((item) => item.user_id === ID);
            setUserName(selectedUser[0].user_name);
            setEmail(selectedUser[0].user_email);
            setPassword(selectedUser[0].user_password);
            setMobile(selectedUser[0].user_mobile);
            setRoleId(selectedUser[0].role_id);
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, users]);

    const roleList = roles.map((role) => (
        { value: role.role_id, label:  role.role_name}
    ));

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'user_name': userName,
            'user_email': email,
            'user_password': password,
            'user_mobile': mobile,
            'role_id': roleId,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.user_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/user/${MODE === 'ADD' ? 'create' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/user-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setUserName('');
        setEmail('');
        setPassword('');
        setMobile('');
        setRoleId('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} User</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>User Name:</label>
                    <Input 
                        onChange={(e) => setUserName(e.target.value)} 
                        value={userName}
                        size='large' 
                        placeholder='User Name' 
                    />
                </div>
                <div className='control'>
                    <label>Email ID:</label>
                    <Input 
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        size='large' 
                        placeholder='Email ID' 
                    />
                </div>
                <div className='control'>
                    <label>Password:</label>
                    <Input.Password 
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        size='large' 
                        placeholder='Password' 
                    />
                </div>
                <div className='control'>
                    <label>Mobile no:</label>
                    <Input 
                        onChange={(e) => setMobile(e.target.value)}
                        value={mobile}
                        size='large' 
                        placeholder='Mobile no' 
                    />
                </div>
                <div className='control'>
                    <label>Role:</label>
                    <Select
                        placeholder="Select Role"
                        style={{ width: '100%' }}
                        size='large'
                        onChange={(value) => setRoleId(value)}
                        options={roleList}
                        allowClear
                        { ...(roleId && { value: roleId }) }
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default UserForm;
